import { render } from "./Profile.vue?vue&type=template&id=6aad2067&scoped=true"
import script from "./Profile.vue?vue&type=script&lang=js"
export * from "./Profile.vue?vue&type=script&lang=js"

import "./Profile.vue?vue&type=style&index=0&id=6aad2067&scoped=true&lang=css"

import exportComponent from "/var/www/html/eeia-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aad2067"]])

export default __exports__